export default {
  bhUser: {},
  bhUsersFilters: {},
  bhUsers: [],
  bhUserPatients: [],
  loading: false,
  pagination: {}
}
